if (!customElements.get('hoculus-pre-order-modal')) {
  class HoculusPreOrderModal extends HTMLElement {
    constructor() {
      super();

      this.targetText = this.dataset.targetText;
      this.refElementsSelectors = this.dataset.targetSelectors;
      this.isModalOpen = false;
      this.closerEl = this.querySelector('.pre-order-modal-container__close-element');
      this.bindCloseModal = this.closeModal.bind(this);
    }

    connectedCallback() {
      this.insertElement();
    }

    insertElement() {
      if (!this.targetText || !this.refElementsSelectors) return;
      const openerEl = document.createElement('p');
      openerEl.classList.add('pre-order-modal-opener');
      openerEl.textContent = this.targetText;
      this.refElement = document.querySelectorAll(`${this.refElementsSelectors}`)[1];
      this.refElement?.insertAdjacentElement('beforebegin', openerEl);
      openerEl.addEventListener('click', this.openModal.bind(this));
    }

    openModal() {
      this.classList.add('is--active');
      this.isModalOpen = true;
      this.isModalOpen && this.closerEl && this.closerEl.addEventListener('click', this.bindCloseModal);
      document.body.style.overflow = 'hidden';
    }

    closeModal() {
      this.classList.remove('is--active');
      this.isModalOpen = false;
      this.closerEl && this.closerEl.removeEventListener('click', this.bindCloseModal);
      document.body.style.overflow = 'auto';
    }
  }

  customElements.define('hoculus-pre-order-modal', HoculusPreOrderModal);
}
